import {
  PIR_ACTIONS_SEARCH_USERS_START,
  PIR_ACTIONS_SEARCH_USERS_SUCCESS,
  PIR_ACTIONS_SEARCH_USERS_FAIL,
  PIR_ACTIONS_ACTIVE_USERS_FILTERS,
  PIR_ACTIONS_RESET_USER_FILTERS,
  PIR_ACTIONS_IS_ADD_ACTION_POPUP_OPEN,
  PIR_ACTIONS_OPEN_EDITOR_MODAL,
  PIR_ACTIONS_CLOSE_EDITOR_MODAL,
} from 'actions/postIncidentReportActions';

export const defaultState = {
  listLoading: true,
  dataLoaded: false,
  error: false,
  data: [],
  total: 0,
  users: {
    total: 0,
    data: [],
    loading: false,
    activeItems: [],
  },
  isAddActionPopupOpen: false,
  editingActionData: null,
};

export default function postIncidentReportReducer(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case PIR_ACTIONS_SEARCH_USERS_SUCCESS: {
      const { data, total } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          data,
          total,
          loading: false,
        },
      };
    }

    case PIR_ACTIONS_SEARCH_USERS_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }

    case PIR_ACTIONS_SEARCH_USERS_FAIL: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };
    }

    case PIR_ACTIONS_ACTIVE_USERS_FILTERS: {
      const { payload } = action;
      const activeItems = [
        ...state.users.activeItems,
        ...payload.filter(
          item => !state.users.activeItems.find(a => a.id === item.id),
        ),
      ];

      return {
        ...state,
        users: {
          ...state.users,
          activeItems,
        },
      };
    }

    case PIR_ACTIONS_RESET_USER_FILTERS: {
      const { payload } = action;
      return {
        ...state,
        users: {
          ...state.users,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }

    case PIR_ACTIONS_IS_ADD_ACTION_POPUP_OPEN: {
      const { payload } = action;
      return {
        ...state,
        isAddActionPopupOpen: payload,
      };
    }

    case PIR_ACTIONS_OPEN_EDITOR_MODAL: {
      return {
        ...state,
        editingActionData: action.payload,
      };
    }
    case PIR_ACTIONS_CLOSE_EDITOR_MODAL: {
      return {
        ...state,
        editingActionData: null,
      };
    }
    default:
      return state;
  }
}
